module.exports = __webpack_public_path__ + "static/media/home-banner-img-4.b755ea12.jpg";